"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.com.choose_model': 'Wybierz model',
    'ai.com.choose_provider': 'Wybierz dostawcę',
    'ai.com.choose_avatar': 'Wybierz avatar',
};
